import React, { useEffect, useMemo, useState } from 'react';

import { millisToHoursAndMinutesText } from '../../utils/numberFormatter';
import ChapterSelector from '../Common/ChapterSelector/ChapterSelector';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import ModalBase from '../ModalBase/ModalBase';

export default function CustomPracticeExam({
  user,
  isOpen,
  toggle,
  references,
  isLoadingReferences,
  generateCustomPE,
  customPESettings,
  getCustomPESettings,
  isLoadingPESettings,
}) {
  const [selectedChapterIds, setSelectedChapterIds] = useState(new Set());

  const handleGenerate = () => {
    generateCustomPE([...selectedChapterIds]);
    toggle();
  };
  useEffect(() => {
    if (!customPESettings) {
      getCustomPESettings();
    }
  }, []);

  const adaptedReferences = useMemo(() => {
    const refs = references || [];
    return refs.map((item) => ({
      referenceId: item.id,
      referenceName: item.name,
      chapters: item.chapters,
    }));
  }, [references]);

  const chapterQuestionCountMap = useMemo(() => {
    const map = {};
    (references || []).forEach((ref) => {
      (ref.chapters || []).forEach((ch) => {
        map[ch.id] = ch.questionCount || 0;
      });
    });
    return map;
  }, [references]);

  const totalQuestionCount = useMemo(() => {
    let total = 0;
    selectedChapterIds.forEach((id) => {
      total += chapterQuestionCountMap[id] || 0;
    });
    return total;
  }, [selectedChapterIds, chapterQuestionCountMap]);

  const handleSelectionChange = (newSet) => {
    setSelectedChapterIds(newSet);
  };

  return (
    <ModalBase
      isOpen={isOpen}
      toggle={toggle}
      header="CUSTOM PRACTICE EXAM"
      body={
        !isLoadingPESettings && !isLoadingReferences ? (
          <>
            <div className="custom-exam-info">
              <p className="custom-exam-info__description">
                Create a custom practice exam by selecting the chapters you want
                to be evaluated on. The exam will consist of{' '}
                <strong>
                  {customPESettings?.questionCount} randomly selected questions
                </strong>{' '}
                from your chosen chapters and will have a{' '}
                <strong>
                  {millisToHoursAndMinutesText(customPESettings?.timeInMillis)}{' '}
                  time limit
                </strong>
                .
              </p>
            </div>
            <ChapterSelector
              references={adaptedReferences}
              selectedChapterIds={selectedChapterIds}
              onSelectionChange={handleSelectionChange}
            />
            <div className="custom-exam-question-count">
              <span
                className={
                  totalQuestionCount >= customPESettings?.questionCount
                    ? 'enough'
                    : 'not-enough'
                }
              >
                {totalQuestionCount} questions available from selected chapters
                {totalQuestionCount >= customPESettings?.questionCount
                  ? ''
                  : `, you need at least ${customPESettings?.questionCount}`}
              </span>
            </div>
          </>
        ) : (
          <div className="loading-custom-exam-data">
            <CircularLoading />
          </div>
        )
      }
      footer={
        <>
          <button className="modal-base-btn secondary" onClick={toggle}>
            Cancel
          </button>
          <button
            className="modal-base-btn primary"
            onClick={handleGenerate}
            disabled={totalQuestionCount < customPESettings?.questionCount}
          >
            Generate
          </button>
        </>
      }
      className="custom-practice-exam-modal"
    />
  );
}
